var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "resumeProcessModal",
        "data-focus": "false",
        "data-keyboard": "false",
        "data-backdrop": "static",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "form-group form-inline" },
              [
                _c("label", { attrs: { for: "" } }, [_vm._v("廠別：")]),
                _c("multiselect", {
                  attrs: {
                    options: _vm.factoryOptions,
                    multiple: "",
                    "close-on-select": false,
                    placeholder: "請選擇",
                    label: "Name",
                    "track-by": "Guid",
                  },
                  model: {
                    value: _vm.note.FactoryTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.note, "FactoryTypes", $$v)
                    },
                    expression: "note.FactoryTypes",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "form-group form-inline" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("面談職類：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note.Position,
                    expression: "note.Position",
                  },
                ],
                staticClass: "form-control w-100",
                attrs: { type: "text", disabled: "" },
                domProps: { value: _vm.note.Position },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.note, "Position", $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "form-group form-inline" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("面談主管：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note.InterviewSupervisors,
                    expression: "note.InterviewSupervisors",
                  },
                ],
                staticClass: "form-control w-100",
                attrs: { type: "text", disabled: "" },
                domProps: { value: _vm.note.InterviewSupervisors },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.note,
                      "InterviewSupervisors",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "form-group form-inline" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("面談人資：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note.InterviewHRs,
                    expression: "note.InterviewHRs",
                  },
                ],
                staticClass: "form-control w-100",
                attrs: { type: "text", disabled: "" },
                domProps: { value: _vm.note.InterviewHRs },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.note, "InterviewHRs", $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "form-group form-inline" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("報到狀況：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note.OnBoardStatus,
                    expression: "note.OnBoardStatus",
                  },
                ],
                staticClass: "form-control w-100",
                attrs: { type: "text", disabled: "" },
                domProps: { value: _vm.note.OnBoardStatus },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.note, "OnBoardStatus", $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "form-group form-inline" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("聯絡狀況：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note.ContactStatusRemark,
                    expression: "note.ContactStatusRemark",
                  },
                ],
                staticClass: "form-control w-100",
                attrs: { type: "text", maxlength: "200" },
                domProps: { value: _vm.note.ContactStatusRemark },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.note,
                      "ContactStatusRemark",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "form-group form-inline" }, [
              _c("label", { attrs: { for: "" } }, [_vm._v("備註：")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.note.InterviewStatusRemark,
                    expression: "note.InterviewStatusRemark",
                  },
                ],
                staticClass: "form-control w-100",
                attrs: { type: "text", maxlength: "200" },
                domProps: { value: _vm.note.InterviewStatusRemark },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.note,
                      "InterviewStatusRemark",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.closeModal },
              },
              [_vm._v(" 關閉 ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.saveData },
              },
              [_vm._v("儲存")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("履歷歷程")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }